<template>
  <div class="bg-light">
    <div class="d-flex align-items-center projects">
      <img src="../assets/maps.png" class="img-fluid icon">
      <div class="words d-flex flex-column">
        <h2 class="important">Green River Basin</h2>
        <div class="person">
          <p>~24,000 net acres</p>
          <p>95% Federal leases</p>
          <p>Active drilling in the area</p>
          <br>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Projects',

  data() {
    return {

    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.projects{
  padding: 1.5rem;
}
.words{
  padding-left: 2rem;
}
@media (min-width: 800px) {
  .icon{
    width: 50vw;
    height: 100%;
  }
}
@media (max-width: 800px) {
  .icon{
    width: 0vw;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Projects.vue